import { LinkedBrokersBlock } from "./LinkedBrokersBlock";
import { DeactivationGuard, DeactivationGuardParams } from "./types";

// The block waits for the check to finish, so a previous fetch's brokers never flash while it reloads.
export const deactivationGuardOf = ({
  text,
  linkedBrokers,
  isChecking,
}: DeactivationGuardParams): DeactivationGuard => {
  const isBlocked = !isChecking && linkedBrokers.length > 0;
  return {
    content: isBlocked ? (
      <>
        {text}
        <LinkedBrokersBlock brokers={linkedBrokers} action="deactivate" />
      </>
    ) : (
      text
    ),
    isConfirmDisabled: isChecking || isBlocked,
  };
};
